import React, { Component } from 'react';

import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import { API_URL } from '../../config'
import $ from 'jquery'
import { fade } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles';
import MaterialTable from 'material-table'
import { Paper } from '@material-ui/core';
import Swal from 'sweetalert2';

 
class ProductNew extends Component {
  
      columns = [
        { title: "Parent Code", field: "parent_code" },
        { title: "Child Item Code", field: "item_code" },
        { title: "Child Item Desc", field: "item_name",width: "20%" },       
        { title: "Product Family", field: "product_family" },
        { title: "Product Class", field: "product_class" },
      

        
      ]
     ;
    constructor(props) {
      
        super(props); 
        const grid_height= $(window).height()-$(".header-navbar").height()-200;
        this.max_body_heght= grid_height+"px";
        
       
        
        
    }

    SyncItemBlockMaster = (itemCode) => {
      Swal.fire({
        title: 'Sync Item Block Master (Yes / No)',
        text: 'Click Yes to Start the Sync, Cancel to close the Window.',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.isConfirmed) {
            const requestOptions = {
              method: 'GET',
              headers: { 'Content-Type': 'application/json', 'authorization': localStorage.getItem('token') },
            };
            let url = API_URL + "/product_master/SyncItemBlockMaster?item_code=" + itemCode;
            fetch(url, requestOptions)
              .then(res => res.json())
              .then(json => {

                Swal.fire(json.data.msg);

              })
              .catch((e) => {

              })

          }


        } else {
          console.log("Not Confirmed");
        }



      }
      );

    };
   
    
     componentDidMount(){  
         console.clear() 
       
         $.ajax({
					type: "POST",	 
					url: API_URL+'/product_master/GetAllItems?',
					async:true,		
				 
				 
					success:  function GetScanDetailsForTInSuccess(responce)
					{	
						responce = eval('(' + responce + ')');
						 console.log(responce);
					}
				});
 
        
    }

    actions_button = [
      {
        icon: 'sync',
        tooltip: 'Sync Item Block Master',
        onClick: (event, rowData) => { this.SyncItemBlockMaster(rowData["item_code"]) }
      }
    ]
    
   
  
    render() {
 
        return (
            <div className="App">
             
              <MaterialTable  components={Paper}
                title="Active Product Listing" minRows={10}
                columns={this.columns}
                options={{ maxBodyHeight: this.max_body_heght,debounceInterval: 700, padding: "dense", filtering: false,
                headerStyle: {
                  position: "sticky",
                  top: "0",
                  backgroundColor: "#64a179",
                  color: "#FFF",
                  fontSize: "0.9em"
                },
                rowStyle: (rowData) => ({
                  fontSize: "1em",
                  backgroundColor:
                    rowData.tableData.id % 2 === 1 ? "#e8f5e2" : "#ffffff"
                }),
                      pageSize: 10,
                      pageSizeOptions: [10, 25 ,50, 75, 100 ],
                      toolbar: true,
                      paging: true
                }}
                data={query =>
                  new Promise((resolve, reject) => {
                    // prepare your data and then call resolve like this:
                    let url = API_URL+'/product_master/GetProductGridData?'
                    let q_search="";
                    let sort="";
                    let order_by="";
                    //searching
                    if (query.search) {
                        q_search=`${query.search}`;
                    }
                    //sorting 
                    if (query.orderBy) {
                        sort= `${query.orderBy.field}`;
                        order_by=`${query.orderDirection}`
                    }
                    url += "&q_search="+q_search
                    url += "&sort="+sort
                    url += "&order_by="+order_by

                    //filtering
                    if (query.filters.length) {
                      const filter = query.filters.map(filter => {
                        return `&${filter.column.field}${filter.operator}${filter.value}`
                      })
                      url += filter.join('')
                    }
                    //pagination
                    url += `&page=${query.page + 1}`
                    url += `&limit=${query.pageSize}`
                    console.clear();

                    fetch(url).then(resp => resp.json()).then(resp => {
                      resolve({
                        data: resp['data']['data'],// your data array
                        page: query.page,// current page number
                        totalCount:  resp['data']['total_records']// total row number
                      });
                    })
        
                  })
                }
                actions={this.actions_button}
              />
            </div>
          );
         


    }
}
export default ProductNew